import React, { useCallback, useEffect, useState } from "react";
import {
  IconButton,
  Grid,
  Box,
  Tooltip,
  Button,
  Paper,
  Modal,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../App.css";
import DraggableElement from "../pages/DraggableElement";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import FormElement from "../components/FormBuilder/FormElement";
import { FormProvider } from "../FormContext";
import { STATUS, USERROLE } from "../utils/commonConstant";
import { fetchClientDetailData, processElement, processParaElementAttr } from "../utils/formUtils";

const ContractMarkelApproveRejectPopupModal = ({
  open,
  onClose,
  elements,
  handleConfirmOpen,
  selectedRow,
  clientId,
  setElements,
}) => {
  const [mergedElements, setMergedElements] = useState([]);

  const fieldMappings = {
    SubcontractorName: "SubcontractorName",
    FirstName: "FirstName",
    LastName: "LastName",
    Email: "Email",
    PersonalNo: "MobileNumber",
    Mobile: "MobileNumber",
    Address: "AddressLine1",
    City: "City",
    RecipientRole: "Subcontractor",
    Zipcode: "Postcode",
    ClientName: "ClientName",
    ClientAddress: "ClientAddress",
  };

  useEffect(() => {
    if (!open) return;
    // Function to process signature elements by disabling them
    const disableSignatureElements = (element) => {
      if (element.type === "signature") {
        return { ...element, props: { ...element.props, disabled: true } };
      }

      if (element.type === "horizontalContainer" && element.items) {
        element.items = element.items.map(disableSignatureElements);
      }

      return element;
    };
    async function fetchData() {
      try {
        const data = await fetchClientDetailData(clientId);
        if (data.ClientAddress) {
          data.ClientAddress = data.ClientAddress.replace(/\n/g, ", ");
        }
        console.log(data, "Data");
        if (data && elements) {
          const processList = (list) =>
            list.map((element) => {
              return processElement(element, data, fieldMappings);
            });
          const processedElements = processList(elements);
          // Disable signature elements
          const updatedElements = processedElements.map(
            disableSignatureElements
          );
          const processParaAttrList = (list) =>
            list.map((element) => {
              return processParaElementAttr(element, localStorage.getItem("Role"));
            });
          const processedParaElementsAttr = processParaAttrList(updatedElements);
          setMergedElements(processedParaElementsAttr);

          //setMergedElements(updatedElements);
        }
      } catch (error) {
        console.error("Error fetching client data:", error);
      }
    }

    fetchData();
  }, [clientId, open, elements]);

  const insertInlineCSS = () => {
    console.log("CSS insert invoked");
    const commentClass = document.querySelectorAll(".selection-highlight");
    if (commentClass.length > 0) {
      commentClass.forEach((element) => {
        // element.style.backgroundColor = "white";
        // element.style.cursor = "none";
        element.classList.remove("selection-highlight");
      });
    }
  };
  // useEffect(() => {
  //   if (elements) {
  //     const handleLoad = () => {
  //       setTimeout(() => {
  //         if (elements.length > 0) {
  //           //insertInlineCSS();
  //         }
  //       }, 1000); // 1 second delay
  //     };

  //     // Listen for the window load event to ensure the page is fully rendered
  //     if (document.readyState === "complete") {
  //       handleLoad(); // Page is already loaded
  //     } else {
  //       window.addEventListener("load", handleLoad); // Wait for the load event
  //     }

  //     // Cleanup the event listener on unmount
  //     return () => {
  //       window.removeEventListener("load", handleLoad);
  //     };
  //   }
  // }, [elements]);
  const updateElementProps = useCallback(
    (id, newProps) => {
      const updateProps = (elements) => {
        return elements
          .map((element) => {
            if (element.id === id) {
              if (newProps.remove === true) {
                return null; // Mark element for removal
              }
              return { ...element, props: { ...element.props, ...newProps } };
            }
            if (element.items) {
              const updatedItems = updateProps(element.items).filter(
                (item) => item !== null
              );
              return { ...element, items: updatedItems };
            }
            return element;
          })
          .filter((element) => element !== null); // Remove marked elements
      };
      setMergedElements((prevElements) => updateProps(prevElements));
      setElements((prevElements) => updateProps(prevElements))
    },
    [setMergedElements, setElements]
  );

  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    overflowY: "auto",
    maxHeight: "90vh",
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="form-preview-title"
      aria-describedby="form-preview-description"
      sx={{ backgroundColor: "#CCCCCC" }}
      disableEnforceFocus
      disableAutoFocus
    >
      <Box
        sx={{
          ...modalStyle,
          position: "relative",
          overflowY: "auto",
          backgroundColor: "#CCCCCC",
        }}
      >
        <Box
          sx={{
            position: "sticky",
            top: 8,
            right: 8,
            textAlign: "right",
          }}
        >
          <Tooltip title="Close" arrow>
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                color: "black",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
          <Typography variant="caption" display="block">
            Close
          </Typography>
        </Box>
        <FormProvider>
          <Box minHeight="100vh" sx={{ mt: 2 }}>
            <Grid container justifyContent="center">
              <Grid item xs={12} md={8}>
                <DndContext
                  autoScroll={false}
                  collisionDetection={closestCenter}
                >
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Paper
                          elevation={3}
                          sx={{ padding: 2, minHeight: "700px" }}
                        >
                          <Grid container spacing={2}>
                            <SortableContext
                              items={elements}
                              strategy={verticalListSortingStrategy}
                            >
                              {mergedElements.map((element, index) => (
                                <Grid
                                  xs={12}
                                  item
                                  key={element.id}
                                  sx={{
                                    ...(element.type === "signature" ||
                                      element.type === "fileUpload"
                                      ? { pageBreakInside: "avoid" }
                                      : {}),
                                    ...(element.type === "logo" && {
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }),
                                  }}
                                >
                                  <DraggableElement
                                    id={element.id}
                                    index={index}
                                  >
                                    <FormElement
                                      element={element}
                                      onPropsChange={(newProps, forceSave = true) =>
                                        updateElementProps(element.id, newProps)
                                      }
                                      dragHandle={false}
                                      formPreview={true}
                                      trackChangeDisplayBy={USERROLE.MARKEL}
                                      isShowTrackHistory={true}
                                    />
                                  </DraggableElement>
                                </Grid>
                              ))}
                            </SortableContext>
                          </Grid>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Box>
                </DndContext>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  marginTop: "20px",
                  marginBottom: "20px",
                  textAlign: "center",
                }}
              >
                <Box sx={{ marginTop: 2 }}>
                  <Button
                    variant="contained"
                    color="success"
                    sx={{
                      fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
                      padding: {
                        xs: "10px 16px",
                        sm: "12px 18px",
                        md: "14px 20px",
                      },
                      marginRight: 2,
                    }}
                    onClick={() =>
                      handleConfirmOpen(STATUS.APPROVED, selectedRow)
                    }
                  >
                    Approve
                  </Button>

                  <Button
                    variant="contained"
                    color="error"
                    sx={{
                      fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
                      padding: {
                        xs: "10px 16px",
                        sm: "12px 18px",
                        md: "14px 20px",
                      },
                    }}
                    onClick={() =>
                      handleConfirmOpen(STATUS.REJECTED, selectedRow)
                    }
                  >
                    Reject
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </FormProvider>
      </Box>
    </Modal>
  );
};

export default ContractMarkelApproveRejectPopupModal;
